import type { Field } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';
import type { IssuesRemote } from '@atlassian/jira-polaris-remote-issue/src/controllers/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { defaultJiraUpdateService } from '../common/index.tsx';
import { LABELS } from '../constants.tsx';
import type { JiraFieldMapping } from '../types.tsx';

export const jiraLabelsMapping = (
	issuesRemote: IssuesRemote,
	field: Field,
): JiraFieldMapping<string[]> => ({
	field,
	getValueFromJiraIssue: (issue) => issue.fields[field.key] ?? undefined,
	getFieldValueForJiraUpdate: (value) => (value !== undefined ? value : null),
	getFieldValueForJiraBulkUpdate: (value) => {
		const labels = value.map((label) => ({
			name: label,
		}));
		const bulkEditMultiSelectFieldOptionNext = labels.length > 0 ? 'REPLACE' : 'REMOVE_ALL';
		const bulkEditMultiSelectFieldOptionLegacy = labels.length > 0 ? 'ADD' : 'REMOVE_ALL';
		return {
			[LABELS]: {
				fieldId: field.key,
				labels,
				bulkEditMultiSelectFieldOption: fg('jpd_fix_bulk_edit_label_mapping')
					? bulkEditMultiSelectFieldOptionNext
					: bulkEditMultiSelectFieldOptionLegacy,
			},
		};
	},
	isMultiValueField: true,
	isSupportedByIssueUpdateApi: true,
	...defaultJiraUpdateService(issuesRemote, field.key),
});
